var HSForm_FormHelpers = new Object();
HSForm_FormHelpers.version = "1.0.1";

HSForm_FormHelpers.field_privacyConsent = function ($form, terms) {
  // Setup Privacy Consent Field
  if (terms !== "ignore") {
    terms = terms.split(",");
    helpers.hsPrivacyConsentInit(
      $form,
      terms[0],
      terms.constructor === Array ? terms[1] : "thryvcornflower",
    );
  }
  const $consentField = $form.find(
    'input[name^="LEGAL_CONSENT.subscription_type_"]',
  );
  const $optOutField = $form.find('input[name="smsoptout__c"]');
  const showPrivacyConsentError = function () {
    $consentField.addClass("invalid error");
    if ($consentField.closest(".input").next(".hs-error-msgs").length <= 0) {
      $consentField
        .closest(".input")
        .after(
          '<ul class="no-list hs-error-msgs inputs-list" role="alert"><li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li></ul>',
        );
    } else {
      $consentField
        .closest(".input")
        .next(".hs-error-msgs")
        .html(
          '<li><label class="hs-error-msg hs-main-font-element">Please confirm that you have read and agree to the privacy statement by checking the box.</label></li>',
        );
    }
  };

  $consentField.change(function () {
    if ($(this).is(":checked")) {
      $consentField.removeClass("invalid error");
      $consentField.closest(".input").next(".hs-error-msgs").remove();
      $optOutField.val("false");
    } else {
      showPrivacyConsentError();
      $optOutField.val("true");
    }
  });
};

HSForm_FormHelpers.setFieldLabelVisibilty = function ($form) {
  const inputFields = $form.find(
    'input:not([type="checkbox"],[type="radio"],[type="hidden"])',
  );
  inputFields.each(function () {
    if (this.value) {
      $(this).closest(".hs-form-field").addClass("show-field-label");
    }
  });
  inputFields
    .focus(function () {
      $(this).closest(".hs-form-field").addClass("show-field-label");
    })
    .blur(function () {
      if (!this.value) {
        $(this).closest(".hs-form-field").removeClass("show-field-label");
      }
    });
};

HSForm_FormHelpers.field_name = function ($form) {
  const $nameField = $form.find(
    'input[name="full_name"],input[name="referral_client_name"]',
  );
  const $mainNameField = $form.find('input[name="full_name"]');
  const $firstName = $form.find('input[name="firstname"]');
  const $lastName = $form.find('input[name="lastname"]');
  const errorMsg = `
    <ul class="no-list hs-error-msgs inputs-list" role="alert">
      <li>
        <label class="hs-error-msg hs-main-font-element">
          Please ensure you enter a first and last name with more than 2 letters and no special characters.
        </label>
      </li>
    </ul>
  `;
  const nameRegex =
    /^([a-zA-Z.]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)$/;

  if ($mainNameField.attr("type") === "hidden") {
    $firstName.on("input blur", function () {
      if (helpers.shouldDebug("hsForm"))
        console.log("[HSForm.FormHelpers] firstName:", $firstName.val());
      $mainNameField.val($firstName.val() + " " + $lastName.val());
      if (helpers.shouldDebug("hsForm"))
        console.log(
          "[HSForm.FormHelpers] mainNameField:",
          $mainNameField.val(),
        );
    });
    $lastName.on("input blur", function () {
      if (helpers.shouldDebug("hsForm"))
        console.log("[HSForm.FormHelpers] lastName:", $lastName.val());
      $mainNameField.val($firstName.val() + " " + $lastName.val());
      if (helpers.shouldDebug("hsForm"))
        console.log(
          "[HSForm.FormHelpers] mainNameField:",
          $mainNameField.val(),
        );
    });
  } else {
    $nameField.on("input blur", function (e) {
      const $currNameField = $(e.target);

      if (!nameRegex.test($currNameField.val().trim())) {
        $currNameField.addClass("invalid error");

        const $errorBlock = $currNameField
          .closest(".input")
          .next(".hs-error-msgs");
        if ($errorBlock.length <= 0) {
          $currNameField.closest(".input").after(errorMsg);
        } else {
          $errorBlock.html($(errorMsg).html());
        }
      } else {
        $currNameField.removeClass("invalid error");
        $currNameField.closest(".input").next(".hs-error-msgs").remove();
      }

      if ($(e.target).attr("name") === "full_name") {
        const val = $(this).val().trim();
        const parts = val.split(/\s+/);
        $firstName.val(parts[0] || "");
        $lastName.val(parts.slice(1).join(" ") || "");
      }
    });
  }
};

HSForm_FormHelpers.field_textarea = function ($form) {
  const textarea = $form.find("textarea");

  textarea.each(function () {
    // Setup textarea character count
    if (this.hasAttribute("maxlength")) {
      $(this).after(
        '<span class="char-count" style="opacity:0;"><span class="num"></span> chars</span>',
      );
      $(this).on("input keyup keydown", function (e) {
        let charcount = $(this).val().length;
        let field = $(this).closest(".hs-form-field");

        if (!field.hasClass("show-char-count"))
          field.addClass("show-char-count");

        if ($(this).attr("maxlength").length > 0) {
          if (!field.find("span.char-count").text().includes("left"))
            field.find("span.char-count").append(" left");

          let maxlength = $(this).attr("maxlength");
          field.find("span.num").text(maxlength - charcount);
        } else {
          field.find("span.num").text(charcount);
        }
      });

      $(this).blur(function () {
        $(this).closest(".hs-form-field").removeClass("show-char-count");
      });
    }

    // Setup textarea word count
    if (this.hasAttribute("word-count")) {
      $(this).after(
        '<span class="word-count" style="opacity:0;"><span class="num"></span> words</span>',
      );
      $(this).on("input keyup keydown", function (e) {
        let words = this.value
          .trim()
          .split(/\s+/)
          .filter((word) => word.length > 0);
        let wordcount = words.length;
        let maxlength = parseInt($(this).attr("word-count"));
        let field = $(this).closest(".hs-form-field");

        if (!field.hasClass("show-word-count"))
          field.addClass("show-word-count");

        if ($(this).attr("word-count").length > 0) {
          if (!field.find("span.word-count").text().includes("left"))
            field.find("span.word-count").append(" left");

          field.find("span.num").text(maxlength - wordcount);
        } else {
          field.find("span.num").text(wordcount);
        }
      });

      $(this).blur(function () {
        $(this).closest(".hs-form-field").removeClass("show-word-count");
      });
    }
  });
};

HSForm_FormHelpers.field_website = function ($form) {
  const $websiteField = $form.find('[name="website"]');
  const errorMsg = `
    <ul class="no-list hs-error-msgs inputs-list" role="alert">
      <li>
        <label class="hs-error-msg hs-main-font-element">
          Please enter a valid website url.
        </label>
      </li>
    </ul>
  `;
  $websiteField.on("input keyup blur", function () {
    if (!helpers.isDomain($websiteField.val())) {
      $websiteField.addClass("invalid error");

      const $errorBlock = $websiteField
        .closest(".input")
        .next(".hs-error-msgs");
      if ($errorBlock.length <= 0) {
        $websiteField.closest(".input").after(errorMsg);
      } else {
        $errorBlock.html($(errorMsg).html());
      }
    } else {
      $websiteField.removeClass("invalid error");
      $websiteField.closest(".input").next(".hs-error-msgs").remove();
    }
  });
};

HSForm_FormHelpers.field_industry = function ($form) {
  // Setup Industry Fields Fns
  if ($form.find('input[name="industry"]').length > 0) {
    $form.find('input[name="industry"]').closest(".hs-form-field").hide();
    $form.find('select[name="industry_select"]').change(function () {
      $form.find('input[name="industry"]').val($(this).val());
      if ($(this).val() === "Other") {
        $form
          .find('input[name="industry"]')
          .closest(".hs-form-field")
          .slideDown(200);
      } else {
        $form
          .find('input[name="industry"]')
          .closest(".hs-form-field")
          .slideUp(200);
      }
    });
  } else {
    $form
      .find('select[name="industry_select"]')
      .closest(".hs-form-field")
      .hide();
  }
};

HSForm_FormHelpers.field_adp4 = function ($form) {
  var _parent = HSForm;
  let adp4 = _parent.$el[0].getAttribute("form-adp4");
  let adp4Field = $form.find('[name="additional_datapoint_4"]');
  if (!_parent.$el[0].hasAttribute("form-adp4") || adp4Field.length <= 0)
    return false;
  adp4Field.val(adp4);
  if (helpers.shouldDebug("hsForm"))
    console.log("[HSForm.FormHelpers] adp4:", adp4Field.val());
};

HSForm_FormHelpers.field_baSFID = function ($form) {
  var _parent = HSForm;
  var baProfile = _parent.$el.closest(".ba-profile-wrapper");

  if (baProfile.length > 0) {
    $form.find('[name="direct_assignment_rep"]').val(baProfile.data("sfid"));
  }
};

HSForm_FormHelpers.fields_utms = function ($form) {
  // Check if any parameter are in the shortcode
  var _parent = HSForm;
  var $parentEl = _parent.$el;
  const shortcode_utms = $parentEl[0].hasAttribute("form-utms")
    ? $parentEl.attr("form-utms").split(",")
    : false;
  if (shortcode_utms) {
    shortcode_utms.map((utm, i) => {
      const utm_names = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
      ];
      if (utm !== "") {
        $form.find(`input[name="${utm_names[i]}"]`).val(utm);
      }
    });
  }

  // Check if any parameters are in the url
  const urlParams = new URLSearchParams(window.location.search);
  const url_utms = {
    utm_source: urlParams.get("utm_source"),
    utm_medium: urlParams.get("utm_medium"),
    utm_campaign: urlParams.get("utm_campaign"),
    utm_term: urlParams.get("utm_term"),
    utm_content: urlParams.get("utm_content"),
  };

  Object.entries(url_utms).forEach(([key, value]) => {
    if (value !== null) {
      $form.find(`input[name="${key}"]`).val(value);
    }
  });

  if ($form.find('input[name="utm_medium"]').val() === "") {
    if (helpers.shouldDebug("hsForm"))
      console.info("[HSForm.FormHelpers] set default utm_medium");
    $form.find('input[name="utm_medium"]').val("website");
  }

  const impactId = urlParams.get("irclickid");
  if (impactId) {
    $form.find('input[name="impact_id"]').val(impactId);
  }

  $form.find('input[name^="utm_"]').each(function () {
    if (helpers.shouldDebug("hsForm"))
      console.log(
        `[HSForm.FormHelpers] ${$(this).attr("name")}: ${$(this).val()}`,
      );
  });
};

HSForm_FormHelpers.fields_country = function ($form) {
  // Set country code for form
  let countryCode = thryvSettings.thryvCountry.slice(0, 2);
  $form.find('[name="country_code"]').val(countryCode);
};

HSForm_FormHelpers.submitForm = function ($form) {
  var _parent = HSForm;

  if (helpers.shouldDebug("hsForm"))
    console.log("[HSForm.FormHelpers] submitForm", _parent.count++);

  // console.log('HSForm_FormHelpers.submitForm...!');

  const $submitBtn = this.getSubmitBtn($form);
  $submitBtn.prop("disabled", false);
  $submitBtn.trigger("click");

  _parent.$el.find(".form-instructions").hide();
  $form.hide();
};

export default HSForm_FormHelpers;
